import React from 'react';
import { Frame, Icon, SageClassnames, SageTokens } from '@kajabi/sage-react';
import PropTypes from 'prop-types';

import { MockItem } from './MockItem';

export const Podcast = ({ breakpoints, hideOrExpandSection }) => {
  return (
    <Frame gap={Frame.GAPS.NONE}>
      <Frame
        direction={Frame.DIRECTIONS.HORIZONTAL}
        padding={Frame.PADDINGS[breakpoints.sm ? 'SM' : 'MD']}
      >
        <Frame align={Frame.ALIGNMENTS.CENTER_LEFT} style={{ height: '100%' }}>
          <MockItem
            color="#8E5AD8"
            height={12}
            width={87}
          />
        </Frame>
        <Frame
          align={Frame.ALIGNMENTS.CENTER_RIGHT}
          direction={
            Frame.DIRECTIONS[breakpoints.sm ? 'VERTICAL' : 'HORIZONTAL']
          }
          gap={Frame.GAPS[breakpoints.sm ? '2XS' : 'MD']}
        >
          {Array(breakpoints.sm ? 3 : 5)
            .fill()
            .map((_, index) => (
              <MockItem
                color="#C7ACEC"
                height={8}
                key={`podcast-page-header-${index}`}
              />
            ))}
        </Frame>
      </Frame>
      <Frame
        className={hideOrExpandSection(1)}
      >
        <Frame
          background={SageTokens.COLOR_PALETTE.PURPLE_100}
          padding={Frame.PADDINGS[breakpoints.sm ? 'MD' : 'XL']}
        >
          <Frame
            align={Frame.ALIGNMENTS.CENTER_CENTER}
            direction={Frame.DIRECTIONS[breakpoints.sm ? "VERTICAL" : "HORIZONTAL"]}
            style={{ maxWidth: 720, margin: 'auto' }}
          >
            <Frame
              align={Frame.ALIGNMENTS.CENTER_CENTER}
              background="#C7ACEC"
              borderRadius={Frame.BORDER_RADII.MD}
              style={{ width: 150, height: 150 }}
            >
              {breakpoints.sm || <Icon color={Icon.COLORS.PURPLE_300} icon={Icon.ICONS.PLAY} />}
            </Frame>
            <Frame align={Frame.ALIGNMENTS[breakpoints.sm ? 'CENTER_CENTER' : 'TOP_LEFT']}>
              <MockItem
                color="#8E5AD8"
                height={12}
                width="20%"
              />
              <MockItem
                color="#C7ACEC"
                height={12}
                width="25%"
              />
              {
                breakpoints.sm ? <Frame
                  align={Frame.ALIGNMENTS.CENTER_CENTER}
                  background={SageTokens.COLOR_PALETTE.WHITE}
                  padding={Frame.PADDINGS.SM}
                  style={{ width: 100, borderRadius: 100 }}
                >
                  <Icon color={Icon.COLORS.PURPLE_300}  icon={Icon.ICONS.PLAY} />
                </Frame> : <>
                  <MockItem
                    color="#C7ACEC"
                    height={12}
                    width="100%"
                  />
                  <div
                    style={{
                      backgroundColor: "#8E5AD8",
                      borderRadius: 8,
                      height: 36,
                      width: 100,
                    }}
                  >
                    &nbsp;
                  </div>
                </>
              }
            </Frame>
          </Frame>
        </Frame>
        {Array(breakpoints.sm ? 1 : 2)
          .fill()
          .map((_, index) => (
            <Frame
              className={hideOrExpandSection(2)}
              key={`podcast-section-${index}`}
              style={{ maxWidth: 720, margin: 'auto' }}
            >
              <Frame
                align={Frame.ALIGNMENTS[breakpoints.sm ? 'TOP_LEFT' : 'CENTER_CENTER']}
                background={SageTokens.COLOR_PALETTE[breakpoints.sm ? 'WHITE' : 'PURPLE_100']}
                padding={Frame.PADDINGS.MD}
                gap={Frame.GAPS.SM}
              >
                <Frame direction={Frame.DIRECTIONS.HORIZONTAL}>
                  {breakpoints.sm || <Frame background="#C7ACEC" style={{width: 80, height: 80}} />}
                  <Frame gap={Frame.GAPS.SM}>
                    <MockItem
                      color={breakpoints.sm ? "#8E5AD8" : SageTokens.COLOR_PALETTE.WHITE}
                      height={8}
                      width={50}
                    />
                    <MockItem
                      color={breakpoints.sm ? "#C7ACEC" : "#8E5AD8"}
                      height={12}
                      width={125}
                    />
                    <MockItem
                      color={breakpoints.sm ? "#F2EBFA" : SageTokens.COLOR_PALETTE.WHITE}
                      height={8}
                      width={100}
                    />
                  </Frame>
                </Frame>
                <Frame
                  align={Frame.ALIGNMENTS.CENTER_CENTER}
                  background={breakpoints.sm ? "#F2EBFA" : SageTokens.COLOR_PALETTE.WHITE}
                  padding={Frame.PADDINGS.SM}
                  style={{ width: 100, borderRadius: 100 }}
                >
                  <Icon color={Icon.COLORS.PURPLE_300}  icon={Icon.ICONS.PLAY} />
                </Frame>
              </Frame>
              {
                breakpoints.sm || <Frame gap={Frame.GAPS.XS}>
                  <MockItem
                    color="#C7ACEC"
                    height={8}
                    width={240}
                  />
                  <MockItem
                    color="#C7ACEC"
                    height={8}
                    width={140}
                  />
                  <MockItem
                    color="#C7ACEC"
                    height={8}
                    width={80}
                  />
                </Frame>
              }
            </Frame>
          ))}
      </Frame>
    </Frame>
  );
};

Podcast.propTypes = {
  breakpoints: PropTypes.shape({}).isRequired,
  hideOrExpandSection: PropTypes.func.isRequired,
};
